"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseClient = exports.BaseResponse = void 0;

var BaseResponse = /*#__PURE__*/function () {
  function BaseResponse() {
    (0, _classCallCheck2.default)(this, BaseResponse);
  }

  (0, _createClass2.default)(BaseResponse, [{
    key: "ok",
    get:
    /**
     * Returns whether the response has an ok'ish status code
     */
    function get() {
      return this.status >= 200 && this.status <= 299;
    }
    /**
     * Returns the status code of the response
     */

  }, {
    key: "status",
    get: function get() {
      throw new Error('not implemented');
    }
    /**
     * Returns the value of the specified header
     * @param {string} headerName the header name
     * @returns {string} the header value
     */

  }, {
    key: "getHeader",
    value: function getHeader(headerName) {
      throw new Error('not implemented');
    }
    /**
     * @returns {ArrayBuffer} the response data of the request
     */

  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('not implemented');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }]);
  return BaseResponse;
}();

exports.BaseResponse = BaseResponse;

var BaseClient = /*#__PURE__*/function () {
  function BaseClient(url) {
    (0, _classCallCheck2.default)(this, BaseClient);
    this.url = url;
  }
  /**
   * Send a request with the options
   * @param {object} [options]
   */


  (0, _createClass2.default)(BaseClient, [{
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _ref,
            headers,
            credentials,
            signal,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, credentials = _ref.credentials, signal = _ref.signal;
                throw new Error('request is not implemented');

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);
  return BaseClient;
}();

exports.BaseClient = BaseClient;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFBYUEsWTs7Ozs7Ozs7SUFDWDs7O0lBR0EsZUFBTTtNQUNKLE9BQU8sS0FBS0MsTUFBTCxJQUFlLEdBQWYsSUFBc0IsS0FBS0EsTUFBTCxJQUFlLEdBQTVDO0lBQ0Q7SUFFRDs7Ozs7O1NBR0EsZUFBVTtNQUNSLE1BQU0sSUFBSUMsS0FBSixDQUFVLGlCQUFWLENBQU47SUFDRDtJQUVEOzs7Ozs7OztXQUtBLG1CQUFVQyxVQUFWLEVBQW9CO01BQ2xCLE1BQU0sSUFBSUQsS0FBSixDQUFVLGlCQUFWLENBQU47SUFDRDtJQUVEOzs7Ozs7OzZGQUdBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUEsTUFDUSxJQUFJQSxLQUFKLENBQVUsaUJBQVYsQ0FEUjs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7O0FBM0JGRTs7SUFnQ2FDLFU7RUFDWCxvQkFBWUMsR0FBWixFQUFlO0lBQUE7SUFDYixLQUFLQSxHQUFMLEdBQVdBLEdBQVg7RUFDRDtFQUVEOzs7Ozs7Ozs7NkZBSUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBOztRQUFBO1VBQUE7WUFBQTtjQUFBO2dCQUFBLGtFQUFpRCxFQUFqRCxFQUFnQkMsT0FBaEIsUUFBZ0JBLE9BQWhCLEVBQXlCQyxXQUF6QixRQUF5QkEsV0FBekIsRUFBc0NDLE1BQXRDLFFBQXNDQSxNQUF0QztnQkFBQSxNQUNRLElBQUlQLEtBQUosQ0FBVSw0QkFBVixDQURSOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7Ozs7QUFURkUiLCJuYW1lcyI6WyJCYXNlUmVzcG9uc2UiLCJzdGF0dXMiLCJFcnJvciIsImhlYWRlck5hbWUiLCJleHBvcnRzIiwiQmFzZUNsaWVudCIsInVybCIsImhlYWRlcnMiLCJjcmVkZW50aWFscyIsInNpZ25hbCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9kaXN0LW1vZHVsZS9zb3VyY2UvY2xpZW50L2Jhc2UuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=